export default (state = {}, action) => {
  switch (action.type) {
    case 'ADD_USER_INFO_PERMISSION':
      return { ...state, userInfo: action.userInfo };
    case 'ADD_USER_ID':
      return { ...state, userID: action.userID };
    case 'ADD_COMPANY_ID':
      return { ...state, idPessoaEmpresa: action.idPessoaEmpresa };
    default:
      return state;
  }
};
